import { cilCart, cilLayers, cilPushchair, cilSpeedometer } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CNavItem, CNavTitle, CNavGroup } from '@coreui/react-pro';

import { SYSTEM_ADMIN_PATH } from '../constants';

const systemAdminNav = [
     {
          component: CNavItem,
          name: 'Dashboard',
          to: SYSTEM_ADMIN_PATH.DASHBOARD,
          icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Orders',
          to: SYSTEM_ADMIN_PATH.ORDERS,
          icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Order Refund',
          to: SYSTEM_ADMIN_PATH.ORDERS_REFUND,
          icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Bundled Seats',
          to: SYSTEM_ADMIN_PATH.BUNDLED_SEATS,
          icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Events Credit',
          to: SYSTEM_ADMIN_PATH.EVENT_CREDITS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Shipments',
          to: SYSTEM_ADMIN_PATH.SHIPMENTS,
          icon: <CIcon icon={cilPushchair} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'SOW Orders',
          to: SYSTEM_ADMIN_PATH.SOW_ORDERS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'PEOPLE & GROUPS',
     },
     {
          component: CNavItem,
          name: 'Users',
          to: SYSTEM_ADMIN_PATH.USERS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Organizations',
          to: SYSTEM_ADMIN_PATH.ORGANIZATIONS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Licensees',
          to: SYSTEM_ADMIN_PATH.LICENSEES,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Instructors',
          to: SYSTEM_ADMIN_PATH.INSTRUCTORS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'PRODUCT SETTINGS',
     },
     {
          component: CNavItem,
          name: 'Training Products',
          to: SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Product Types',
          to: SYSTEM_ADMIN_PATH.PRODUCT_TYPES,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Tests',
          to: SYSTEM_ADMIN_PATH.TESTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Surveys',
          to: SYSTEM_ADMIN_PATH.SURVEYS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'CE Packs',
          to: SYSTEM_ADMIN_PATH.CE_PACKS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Certificates',
          to: SYSTEM_ADMIN_PATH.CERTIFICATES,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Designation Elements',
          to: SYSTEM_ADMIN_PATH.DESIGNATION_ELEMENTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Coupons',
          to: SYSTEM_ADMIN_PATH.COUPONS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Vouchers',
          to: SYSTEM_ADMIN_PATH.VOUCHERS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'PRODUCT DISPLAY',
     },
     {
          component: CNavItem,
          name: 'Selling Groups',
          to: SYSTEM_ADMIN_PATH.SELLING_GROUPS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Selling Group Categories',
          to: SYSTEM_ADMIN_PATH.SELLING_GROUP_CATEGORIES,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'REPORTING',
     },
     {
          component: CNavItem,
          name: 'Survey Reports',
          to: SYSTEM_ADMIN_PATH.SURVEY_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Shipping Reports',
          to: SYSTEM_ADMIN_PATH.SHIPPING_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'CE Reports',
          to: SYSTEM_ADMIN_PATH.CE_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Designation Reports',
          to: SYSTEM_ADMIN_PATH.DESIGNATION_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Order Reports',
          to: SYSTEM_ADMIN_PATH.ORDER_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Training Product Reports',
          to: SYSTEM_ADMIN_PATH.TRAINING_PRODUCT_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Organization Training Reports',
          to: SYSTEM_ADMIN_PATH.ORGANIZATION_TRAINING_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Seat Availability Reports',
          to: SYSTEM_ADMIN_PATH.SEAT_AVAILABILITY_REPORTS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavGroup,
          toggler: (
               <>
                    <CIcon icon={cilLayers} customClassName="nav-icon" />
                    SOW Reports
               </>
          ),

          items: [
               {
                    component: CNavItem,
                    name: 'Total Order',
                    to: SYSTEM_ADMIN_PATH.SOW_TOTAL_ORDER_REPORTS,
                    icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
               },
               {
                    component: CNavItem,
                    name: 'Training Usage',
                    to: SYSTEM_ADMIN_PATH.SOW_TRAINING_USAGE_REPORTS,
                    icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
               },
          ],
     },
     {
          component: CNavTitle,
          name: 'CONTENT MANAGEMENT',
     },
     {
          component: CNavItem,
          name: 'Integrations',
          to: SYSTEM_ADMIN_PATH.INTEGRATIONS,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
     {
          component: CNavItem,
          name: 'Content Management',
          to: SYSTEM_ADMIN_PATH.UNIVERSAL_CONTENT_MANAGEMENT,
          icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
     },
];

export default systemAdminNav;
